import { getLocalizedString } from "@grandvisionhq/utils";
const getProductTitle = (orderLineItem, intl) => {
  if (orderLineItem.product.currentProduct?.type === "SUNGLASSES") {
    return orderLineItem.product.brand || getLocalizedString(orderLineItem.product.name, intl.locale);
  }
  return getLocalizedString(orderLineItem.product.name, intl.locale);
};
export {
  getProductTitle
};
//# sourceMappingURL=get-product-title.js.map
